/**
 * 获取浏览器的参数
 * @param url
 */
export const getURLParams = (url: any = window.location.href, param?: string) => {
  const paramArr = url.match(/([^?=&]+)(=([^&]*))/g) || [];
  const paramsObj = {};
  for (const queryPair of paramArr) {
    const [key, value] = queryPair.split('=');
    paramsObj[key] = value;
  }
  return param ? paramsObj[param] : paramsObj;
};
